// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-cell {
  color: dimgray !important;
}

.main-col {
  color: black !important;
  font-weight: bolder;
}

.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {
  color: rgba(0, 0, 0, 0.54);
}

.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__trailing,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__notch,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__leading {
  border: none !important;
}

.mat-mdc-dialog-content {
  margin: unset;
  height: 100%;
  padding-bottom: 20px;
}

.fixActionRow {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.spacer {
  flex-grow: 1;
}

.bt-spinner {
  display: inline;
  padding-right: 30px;
}

.dialog-title {
  position: relative;
  background-color: #aa488d !important;
  background: linear-gradient(45deg, #04488f, transparent);
  color: #fff;
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
}
.dialog-title .advertiser_name {
  text-align: center;
}
.dialog-title .budget {
  text-align: right;
  padding-right: 20px;
}
.dialog-title .close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
}

.title {
  font-weight: bolder;
  color: #0175c0;
}

.row {
  padding-bottom: 20px;
}
.row.separated {
  border-top: 1px solid lightgray;
  padding-top: 20px;
}
.row .grid {
  height: 100%;
  min-height: 100%;
  min-width: 100%;
  width: 100%;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0px;
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.scss","webpack://./src/app/components/dialogs/cardinfodialog/card-info-dialog.component.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;ACzEF;;AD2EA;EACE,uBAAA;EACA,mBAAA;ACxEF;;AD2EA;EACE,0BAAA;ACxEF;;AD6EM;;;EAII,uBAAA;AC3EV;;AAhBA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AAmBF;;AAhBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAmBF;;AAhBA;EACE,YAAA;AAmBF;;AAhBA;EACE,eAAA;EACA,mBAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,oCAAA;EACA,wDAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAmBF;AAjBE;EACE,kBAAA;AAmBJ;AAhBE;EACE,iBAAA;EACA,mBAAA;AAkBJ;AAhBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAkBJ;;AAdA;EACE,mBAAA;EACA,cDgDiB;AC/BnB;;AAdA;EAEE,oBAAA;AAgBF;AAZE;EACE,+BAAA;EACA,iBAAA;AAcJ;AAXE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAaJ","sourcesContent":["@use '@angular/material' as mat;\n// theme.scss\n\n$my-app: (\n  10:  #e8fafb2e,\n  50:  #32c5d22e,\n  100: #32c5d23d,\n  200: orange,\n  300: #32c5d25c,\n  400: #8cdce4,\n  500: #32c5d2c2,\n  600: #32c5d2,\n  700: #1f858e,\n  800: #18666d,\n  900: #337ab7,\n  A100: #ffffff,\n  A200: #def6f8,\n  A400: #a1f3fb,\n  A700: #7aecf7,\n  contrast: (\n    50 : #32c5d25c,\n    100 : #32c5d2c2,\n    200 : white,\n    300 : #1f858e,\n    400 : #18666d,\n    500 : #337ab7,\n    600 : #ffffff,\n    700 : #ffffff,\n    800 : #ffffff,\n    900 : #ffffff,\n    A100 : #32c5d2,\n    A200 : #1f858e,\n    A400 : #18666d,\n    A700 : #337ab7,\n  ));\n\n$my-app-primary: mat.m2-define-palette($my-app, 600);\n$my-app-accent : mat.m2-define-palette($my-app, 900);\n$my-app-warn : mat.m2-define-palette($my-app, 200);\n$my-app-sidebar : mat.m2-define-palette($my-app, 10);\n$my-app-background : mat.m2-define-palette($my-app, 50);\n$my-app-colored-card : mat.m2-define-palette($my-app, 100);\n$my-app-light : mat.m2-define-palette($my-app, 200);\n\n\n$comv-typography-config: mat.m2-define-typography-config(\n\n  $body-1: mat.m2-define-typography-level(14px, 21px, 400) \n  // ...\n);\n\n$my-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $my-app-primary,\n    accent: $my-app-accent,\n    warn: $my-app-warn\n  ),\n  typography: $comv-typography-config,\n  density: 0,\n));\n\n$comv-dark-blue: #26344B;\n$comv-middle-blue: #337ab7;\n$comv-primary-blue: #32c5d2;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab1: #0175c0;\n$comv-tab2: #009BC6;\n$comv-ultralight-gray: rgba(242, 242, 242, 0.15); \n$comv-table-header-border: #a8b7c1;\n\n\n.mat-mdc-cell {\n  color:dimgray !important;\n}\n.main-col {\n  color: black !important;\n  font-weight: bolder;\n}\n\n.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mat-mdc-paginator::ng-deep {\n  .mdc-text-field::ng-deep {\n      .mdc-notched-outline__trailing,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__leading\n       {\n          border: none !important;\n      }\n  }\n}\n\n$comv-blue-dark :#04488f;\n$comv-blue-medium :#0175c0;\n$comv-blue-light :#00b0e1;\n$comv-gray-medium :#8f8f8f;\n$comv-yellow-light :#ecb842;\n$comv-yellow-dark :#e6a540;\n$comv-pink-light :#aa488d;\n$comv-pink-dark :#7d478e;\n$comv-green-light :#8db854;\n$comv-green-dark :#54763f;\n\n\n//$comv-dark-blue: #26344B;\n// $comv-dark-blue : $comv-blue-dark;\n\n//$comv-middle-blue: #337ab7;\n$comv-middle-blue: $comv-blue-medium;\n//$comv-primary-blue: #28b5b9;  \n$comv-primary-blue: $comv-blue-light;\n\n$comv-primary-blue-hover: #32c5d2;  \n\n//$comv-accent-blue: #0065AF;\n$comv-accent-blue: $comv-blue-medium;\n$comv-accent-blue-hover: #0075C9;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-light-blue3: #009BC6; \n$comv-light-blue3-hover: #00b3e3;\n\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab-icon:$comv-middle-blue;\n$comv-tab-icon-hover:$comv-primary-blue;\n\n$comv-grid-highlight: #f6f6f6;\n$comv-grid-hover: #D7F3FB;\n\n$comv-chips-color: $comv-light-gray;\n\n$comv-admo-matched: greenyellow;\n$comv-admo-disabled: lightgray;\n$comv-admo-validated: green;\n$comv-admo-published: $comv-primary-blue;\n$comv-admo-split: #7e478e87;\n$comv-admo-merge: #ffa500;","@import \"../../../../theme/theme.scss\";\n.mat-mdc-dialog-content {\n  margin:unset;\n  height: 100%;\n  padding-bottom: 20px;\n}\n\n.fixActionRow {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.spacer {\n  flex-grow: 1;\n}\n\n.bt-spinner {\n  display: inline;\n  padding-right: 30px;\n}\n\n.dialog-title {\n  position: relative;\n  background-color: $comv-pink-light !important;\n  background: linear-gradient(45deg, $comv-blue-dark, transparent);\n  color: #fff;\n  padding:12px 24px;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  align-items: center;\n\n  .advertiser_name {\n    text-align: center;\n  }\n\n  .budget {\n    text-align: right;\n    padding-right:20px;\n  }\n  .close-icon {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n  }\n}\n\n.title {\n  font-weight: bolder;\n  color: $comv-middle-blue;\n}\n\n.row {\n  // margin-bottom: 20px;\n  padding-bottom: 20px;\n  // &.first {\n  //   padding-bottom: 20px;\n  // }\n  &.separated {\n    border-top: 1px solid lightgray;\n    padding-top: 20px;\n  }\n\n  .grid {\n    height: 100%;\n    min-height: 100%;\n    min-width: 100%;\n    width: 100%;\n    font-size: 14px;\n    line-height: 15px;\n    letter-spacing: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
